<template>
    <div>
        <b-row>
            <b-col cols="12">
                <app-sub-title
                    text="Protocolo COVID-19 Guardas de seguridad"
                ></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <iframe
                    src="https://shatter-webapp-files.s3.amazonaws.com/manuales/PROTOCOLO+COVID+GUARDAS+DE+SEGURIDAD.pdf"
                    width="100%"
                    height="500px"
                >
                </iframe>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    data: () => ({}),
    computed: {},
    methods: {},
}
</script>
